<div class="c-toast" [class.is-error]="toast.type === 'danger'">
    <div role="alert" class="toast c-toast__content" data-autohide="false">
        <p class="c-toast__text">{{ toast.text }} </p>
        <button type="button" *ngIf="false" class="close c-toast__close" data-dismiss="toast">
            cerrar
        </button>
    </div>    
</div>